import { FEATURE_PLAN_ACTION_TYPES } from '@constants/actionTypes/featurePlanActionTypes';

interface IAction {
    type: string;
    payload?: any;
}

export const INITIAL_STATE = {
    serffDocList: [],
    uploadTemplateSuccessMessage: '',
    uploadTemplateFailureMessage: '',
    uploadTemplateErrorMessage: '',
    issuerName: '',
    encIssuerId: '',
    hiosIssuerId: '',
    ssioEnabled: false,
    enableFeaturedPlans: false,
    turquoisePlansEnabled: false,
    year: NaN,
};

export default (state = INITIAL_STATE, action: IAction) => {
    switch (action?.type) {
        case FEATURE_PLAN_ACTION_TYPES.SET_FEATURE_PLAN_LIST: {
            return {
                ...state,
                serffDocList: action.payload,
            };
        }
        case FEATURE_PLAN_ACTION_TYPES.SET_CURRENT_YEAR: {
            return {
                ...state,
                year: action.payload,
            };
        }
        case FEATURE_PLAN_ACTION_TYPES.SET_UPLOAD_TEMPLATE_SUCCESS_MESSAGE: {
            return {
                ...state,
                uploadTemplateSuccessMessage: action.payload,
            };
        }
        case FEATURE_PLAN_ACTION_TYPES.SET_UPLOAD_TEMPLATE_ERROR_MESSAGE: {
            return {
                ...state,
                uploadTemplateErrorMessage: action.payload,
            };
        }
        case FEATURE_PLAN_ACTION_TYPES.SET_UPLOAD_TEMPLATE_FAILURE_MESSAGE: {
            return {
                ...state,
                uploadTemplateFailureMessage: action.payload,
            };
        }
        case FEATURE_PLAN_ACTION_TYPES.SET_SIDEBAR_PARAMS: {
            return {
                ...state,
                ...action.payload,
            };
        }
        default:
            return state;
    }
};
